"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var TableScrollWidth = /** @class */ (function () {
    function TableScrollWidth() {
        var _this = this;
        this.tables = document.querySelectorAll("[".concat(constants_1.DATA_TABLE, "]"));
        this.tables.forEach(function (table) {
            var parentWidth = table.parentElement.clientWidth;
            var tableChild = table.firstChild;
            var tableWidth = tableChild.clientWidth;
            _this.initWidth(table, tableWidth, parentWidth);
            window.addEventListener('resize', function () {
                parentWidth = table.parentElement.clientWidth;
                tableChild = table.firstChild;
                tableWidth = tableChild.clientWidth;
                if (table.parentElement.classList.contains('table--small')) {
                    if (window.innerWidth < 768 && tableWidth > parentWidth) {
                        _this.setCorrectWidth(table);
                        table.classList.remove('d-table');
                    }
                    else {
                        table.style.width = '';
                        table.classList.add('d-table');
                    }
                }
                if (table.parentElement.classList.contains('table--medium')) {
                    if (window.innerWidth < 992 && tableWidth > parentWidth) {
                        _this.setCorrectWidth(table);
                        table.classList.remove('d-table');
                    }
                    else {
                        table.style.width = '';
                        table.classList.add('d-table');
                    }
                }
                if (table.parentElement.classList.contains('table--large')) {
                    _this.setCorrectWidth(table);
                }
            });
        });
    }
    // Calculate the missing width from the table to the right edge of the viewport
    TableScrollWidth.prototype.calcSpaceToRight = function (table) {
        return table.getBoundingClientRect().right - table.getBoundingClientRect().width;
    };
    // Set the width of the table to go the right edge of the viewport
    TableScrollWidth.prototype.setCorrectWidth = function (table) {
        var additionalWidth = this.calcSpaceToRight(table).toString();
        table.style.width = 'calc(100% + ' + additionalWidth + 'px)';
    };
    // Initialize width for tables depending on table size and viewport
    TableScrollWidth.prototype.initWidth = function (table, tableWidth, parentWidth) {
        if (table.parentElement.classList.contains('table--small')) {
            if (window.innerWidth < 768 && tableWidth > parentWidth) {
                this.setCorrectWidth(table);
            }
            else {
                table.style.width = '';
                table.classList.add('d-table');
            }
        }
        if (table.parentElement.classList.contains('table--medium')) {
            if (window.innerWidth < 992 && tableWidth > parentWidth) {
                this.setCorrectWidth(table);
            }
            else {
                table.style.width = '';
                table.classList.add('d-table');
            }
        }
        if (table.parentElement.classList.contains('table--large')) {
            this.setCorrectWidth(table);
        }
    };
    return TableScrollWidth;
}());
exports.default = TableScrollWidth;
